// BFF: ○ gap — legacy macro endpoints, reached through entities/macro. No bff/crm module.
export { default } from './MacroSettings'
